import { DatoCmsPdv } from 'lib/datoCms/queries/getAllPdvLabels';
import { DatoCmsSignUp } from 'lib/datoCms/queries/getAllSignUpLabels';
import { LabelsPrivacyConsents } from '../privacyConsents';

export const getLabelPrivacyConsents = (labels: DatoCmsSignUp | DatoCmsPdv): LabelsPrivacyConsents => {
  return {
    titlePrivacyConsents: labels.titleFifthForm,
    descriptionPrivacyConsents: labels.descriptionFifthForm,
    contractTitle: labels.contractTitle,
    profilingTitle: labels.profilingTitle,
    textFirstConsent: labels.textFirstConsent,
    textSecondConsent: labels.textSecondConsent,
    textThirdConsent: labels.textThirdConsent,
    marketingTitle: labels.marketingTitle,
    acceptanceButton: labels.acceptanceButton,
    acceptAll: labels.acceptAll,
    privacyTitle: labels.privacyTitle,
  };
};
